const Payline = require('Payline');
const Events = require('PSEvents');

const Taxonomy = cc.Class({
    name: 'Taxonomy',
    properties: {
        reel: 5,
        row: 3,
    }
});

cc.Class({
    extends: cc.Component,

    properties: {
        paylinePrefab: cc.Prefab,
        layout: cc.Layout,
        startIndex: 0,
        endIndex: 20,
        taxonomy: Taxonomy
    },

    onLoad() {
        Events.subscribe(Events.COMMON_INITIALIZED, ({ gameConfiguration }) => {
            this._init(gameConfiguration);
        });
    },

    _init({ paylines }) {
        for (let index = this.startIndex; index < this.endIndex; index++) {
            const data = paylines[index];
            if (!data) {
                break;
            }
            const payline = cc.instantiate(this.paylinePrefab);
            payline.getComponent(Payline).init({ data, index, taxonomy: this.taxonomy })
            this.node.addChild(payline);
        }

        this.layout.updateLayout();
    },
});
